export default __webpack_public_path__ + "static/Composite_scalebar_pos88-aeff3af084df4758107a879d0e40120e.png";